"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledTheming = _interopRequireDefault(require("styled-theming"));

var _ = require("./");

var _Constant = require("../../Constant");

var _2 = require("../../");

var _VisuallyHidden = _interopRequireDefault(require("../../VisuallyHidden"));

var _TwoColumnMenuIcons = require("./TwoColumnMenuIcons");

var _theme;

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  display: block;\n  width: 18px;\n  height: 19px;\n  outline: none;\n  color: ", ";\n\n  /* Focus styles on on keyboard focus */\n  &[data-focus-visible-added]:focus {\n    ", "\n    outline-offset: 6px;\n  }\n\n  @media print, screen and (min-width: ", "px) {\n    display: none;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  width: 21px;\n  height: 13px;\n  color: ", ";\n\n  @media print, screen and (min-width: ", "px) {\n    display: none;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  @media print, screen and (min-width: ", "px) {\n    display: none;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  @media print, screen and (max-width: ", "px) {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0 30px;\n    height: 100%;\n    /* border defines space for Windows high contrast mode users */\n    border-bottom: 1px solid transparent;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var focusStyles = (0, _styledTheming.default)('mode', (_theme = {}, (0, _defineProperty2.default)(_theme, _Constant.Themes.CALIBER, "outline: 4px solid ".concat(_Constant.Color.CALIBER_PASTEL_BLUE, ";")), (0, _defineProperty2.default)(_theme, _Constant.Themes.HOMEBRIDGE, "outline: 4px solid ".concat(_Constant.Color.HOMEBRIDGE_BLUE, ";")), (0, _defineProperty2.default)(_theme, _Constant.Themes.HOMEPOINT, "outline: 4px solid ".concat(_Constant.Color.HOMEPOINT_LIGHT_BLUE, ";")), (0, _defineProperty2.default)(_theme, _Constant.Themes.FIGURE, "outline: 4px solid ".concat(_Constant.Color.FOCUS, ";")), (0, _defineProperty2.default)(_theme, _Constant.Themes.PETERSENDEAN, "outline: 4px solid ".concat(_Constant.Color.FOCUS, ";")), (0, _defineProperty2.default)(_theme, _Constant.Themes.PELLA, "outline: 4px solid ".concat(_Constant.Color.FOCUS, ";")), (0, _defineProperty2.default)(_theme, _Constant.Themes.GUARANTEED_RATE, "outline: 4px solid ".concat(_Constant.Color.GUARANTEED_RATE_RAVENSWOOD_GRAY, ";")), _theme));

var Container = _styledComponents.default.div(_templateObject(), _Constant.Width.MD - 1);

var Dropdown = (0, _styledComponents.default)(_2.Dropdown)(_templateObject2(), _Constant.Width.MD);

var Menu = _styledComponents.default.div(_templateObject3(), _Constant.Color.WHITE, _Constant.Width.MD);

var Telephone = _styledComponents.default.a(_templateObject4(), _Constant.Color.WHITE, focusStyles, _Constant.Width.MD);

var TwoColumnSidebarMenu = function TwoColumnSidebarMenu(_ref) {
  var menuList = _ref.menuList,
      phoneNumber = _ref.phoneNumber,
      props = (0, _objectWithoutProperties2.default)(_ref, ["menuList", "phoneNumber"]);
  return /*#__PURE__*/_react.default.createElement(Container, null, menuList.length > 0 && /*#__PURE__*/_react.default.createElement(Dropdown, (0, _extends2.default)({
    toggleButton: /*#__PURE__*/_react.default.createElement(Menu, null, /*#__PURE__*/_react.default.createElement(_TwoColumnMenuIcons.MenuIcon, null), /*#__PURE__*/_react.default.createElement(_VisuallyHidden.default, null, "Menu")),
    menuList: menuList,
    menuStyle: {
      top: '55px',
      left: '0',
      right: '0',
      position: 'fixed',
      borderRight: 'none',
      borderLeft: 'none'
    }
  }, props)), /*#__PURE__*/_react.default.createElement(_.TwoColumnLogo, props), menuList.length > 0 && /*#__PURE__*/_react.default.createElement(Telephone, {
    href: "tel:".concat(phoneNumber)
  }, /*#__PURE__*/_react.default.createElement(_TwoColumnMenuIcons.TelephoneIcon, null), /*#__PURE__*/_react.default.createElement(_VisuallyHidden.default, null, "Have a question? ".concat(phoneNumber))));
};

TwoColumnSidebarMenu.propTypes = {
  menuList: _propTypes.default.arrayOf(_propTypes.default.node),
  phoneNumber: _propTypes.default.string.isRequired
};
TwoColumnSidebarMenu.defaultProps = {
  menuList: []
};
var _default = TwoColumnSidebarMenu;
exports.default = _default;